import React from "react";

import * as UI from "./ui";

const Legal = () => (
  <UI.Legal>
    * By continuing, I certify I am 18 years of age or older, eligible to participate, and I agree to abide by the sweepstakes rules.
  </UI.Legal>
);

export default Legal;
